import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { getDefaultLandingPageByRole } from '@orderna/admin-panel/src/utils/get-default-landing-page';
import { LocalStorageService } from '../../shared/services/local-storage.service';

export const onboardingGuard: CanActivateFn = () => {
  const router = inject(Router);
  const localStorage = inject(LocalStorageService);

  const isOnboarded = localStorage.getIsOnboarded();

  if (isOnboarded) {

    const role = localStorage.getRole();
    if (!role) {
      throw new Error('User role is not defined');
    }

    const defaultLandingPage = getDefaultLandingPageByRole(role);
    return router.parseUrl(defaultLandingPage)
  }

  return true;
};
